/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 08:59:54
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-04-11, 15:52:31
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import ENUM from "es6-enum";
import { createAction } from "helpers/utils";

const GET_BRANDS_LIST = ENUM('STATIC', 'SUCCESS', 'FAIL');
const CHANGE_BRAND = ENUM('STATIC', 'SUCCESS', 'FAIL');

const initialState = {
  list: [],
  current: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_BRANDS_LIST.STATIC:
    case CHANGE_BRAND.STATIC:
      return {
        ...state
      };
    case GET_BRANDS_LIST.SUCCESS:
      return {
        ...state,
        list: action.result,
        current: action.result[0]
      };
    case CHANGE_BRAND.SUCCESS:
      return {
        ...state,
        current: action.result
      };
    case GET_BRANDS_LIST.FAIL:
    case CHANGE_BRAND.FAIL:
      return {
        ...state,
        list: [],
        current: null,
        error: action.error
      };
    default:
      return state;
  }
}

/**
 * Get brands list.
 * 
 * @export
 * @returns 
 */
export function getBrandsList() {
  return createAction(GET_BRANDS_LIST, '/brands', 'get');
}

/**
 * Change brand.
 * 
 * @export
 * @returns 
 */
export function changeBrand(brand = {}) {
  return {
    types: Object.values(CHANGE_BRAND),
    promise: client => new Promise(resolve => resolve(brand))
  };
}


// WEBPACK FOOTER //
// ./src/rcapp/redux/actions/brands.js